import { clientHttp } from '@/shared/api/client'
import { CLIENT_API_ENDPOINTS } from '@/shared/lib'
import { withSessionRetry } from '@/shared/lib/webviewBridge'

import type {
  IChangeReservationProductsRequest,
  ICreateReservationRequest,
  IReservation,
  IUpdateReservationBuyerInfoParams,
} from '../../model'

export const createReservation = async (
  requestData: ICreateReservationRequest
): Promise<IReservation> => {
  return await clientHttp.post(CLIENT_API_ENDPOINTS.RESERVATION.CREATE, {
    body: requestData,
  })
}

/**
 * 상품 저장 — **메인 상품은 건드리지 않는다**
 *
 * 앱이 결제 직전에 부르는 것과 같다(`?updatableMainProduct=false`).
 * 이 값을 빼면 서버가 메인 상품까지 갈아 끼울 수 있다.
 */
export const changeReservationProductsKeepingMain = async (
  reservationId: number,
  requestData: IChangeReservationProductsRequest
): Promise<IReservation> => {
  return withSessionRetry(() =>
    clientHttp.put(
      `${CLIENT_API_ENDPOINTS.RESERVATION.CHANGE_PRODUCTS(reservationId)}?updatableMainProduct=false`,
      { body: requestData }
    )
  )
}

/**
 * 첫 옵션은 createReservation으로 만들고, 나머지 옵션은 reservationProducts에 붙여 PUT한다.
 * 백엔드가 createReservation 응답(IReservation) 객체를 그대로 body로 받는다.
 */
export const changeReservationProducts = async (
  reservationId: number,
  requestData: IChangeReservationProductsRequest
): Promise<IReservation> => {
  return await clientHttp.put(
    CLIENT_API_ENDPOINTS.RESERVATION.CHANGE_PRODUCTS(reservationId),
    { body: requestData }
  )
}

/**
 * 예약 삭제
 *
 * @description
 * 결제 대기(Holding) 예약은 그 시간 슬롯을 잡아 둔다. 결제하지 않고 화면을 떠날 때
 * 지워 주지 않으면 다른 사람이 그 시간을 못 잡는다(서버도 20분 뒤 지우지만 그동안 막힌다).
 */
export const deleteReservation = async ({
  reservationId,
}: {
  reservationId: number
}): Promise<IReservation> => {
  return clientHttp.delete(
    CLIENT_API_ENDPOINTS.RESERVATION.DELETE(String(reservationId))
  )
}

export const getReservationDetail = async ({
  reservationId,
}: {
  reservationId: string
}): Promise<IReservation> => {
  return clientHttp.get(CLIENT_API_ENDPOINTS.RESERVATION.DETAIL(reservationId))
}

export const updateReservationBuyerInfo = async ({
  reservationId,
  macarId,
  carNumber,
  buyerName,
  buyerTelephone,
  keepPersonalInfo = false,
  visitorTelephone,
  requirements,
}: IUpdateReservationBuyerInfoParams): Promise<IReservation> => {
  return clientHttp.put(
    CLIENT_API_ENDPOINTS.RESERVATION.UPDATE_BUYER_INFO(reservationId),
    {
      body: {
        macarId,
        carNumber,
        buyerName,
        buyerTelephone,
        keepPersonalInfo,
        visitorTelephone,
        requirements,
      },
    }
  )
}
